import { makeStyles } from '@material-ui/core/styles';
import { COLORS, FONT_FAMILIES } from './../../../styles/constants';

export const useWdTitleStyles = makeStyles(() => ({
	root: {
		paddingTop: '5px',
		paddingBottom: '5px',
		textAlign: 'center',
		marginBottom: 0,
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,
		borderTopLeftRadius: '4px',
		borderTopRightRadius: '4px',
		fontFamily: FONT_FAMILIES,
		fontSize: '15px',
		color: COLORS.BACKGROUND_GREY_DARK
	},
	span: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		marginBottom: '3px'
	}
}));
